<template>
    <div class="tab-wrapper" v-loading.small="loading">
        <EmptyTabsCard
            v-if="!tabItems.length"
            :emptyImgLink="emptyImgLink"
            cardTitle="Компетенции"
            toFullRouter="/other-skills"
            emptyText="Еще нет компетеций"
            buttonText="Пройти оценку"
        />

        <div class="competences-block" v-else>
            <h3 class="competences-block__title">Компетенции</h3>
            <Tabs v-if="isTabsShown" :items="tabs" v-model="currentType" class="competences-block__tabs" />

            <!--            <span v-if="!tabItems.length" class="competences-block__empty"-->
            <!--                >Вы ничего не добавили</span-->
            <!--            >-->

            <div class="competences-block__buttons">
                <Button :to="catalogLink" class="btn-catalog">Перейти в каталог</Button>
                <Button :to="{ name: 'account-reporting' }" class="btn-reports" outline>
                    <ReportingIcon class="icon" />Персональные отчеты
                </Button>
            </div>

            <span class="empty" v-if="this.currentType === 'hard'">
                Для подтверждения своих профессиональных навыков
                <router-link :to="{ name: 'account-edit' }" target="_blank" class="account-link"
                    >заполните информацию</router-link
                >об образовании и прикрепите фотографию или скан подтверждающего документа
            </span>
            <div v-if="tabItems.length" class="items">
                <div v-for="(group, j) in tabItems" class="competences-group" :key="`group_${group.name}_${j}`">
                    <h3 :key="`group_header_${group.name}_${j}`" v-if="group.name">
                        {{ group.name }}
                    </h3>

                    <div :key="`items_${group.name}_${j}`" class="competences-items">
                        <CompetenceItem
                            v-for="(item, i) in group.items"
                            :key="`${item.id}_${i}`"
                            class="competences-items__item"
                            :item="item"
                            :track-id="getTrackId"
                        />
                    </div>

                    <hr :key="`hr_${j}`" v-if="j < tabItems.length - 1" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CompetenceItem from './tab-competences/components/CompetenceItem';
import Tabs from './tab-competences/components/Tabs';
import Button from '../../UI/Button';
import ReportingIcon from '@/assets/images/icons/reporting2.svg?inline';
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';

export default {
    name: 'TabCompetences',
    components: {
        EmptyTabsCard,
        Button,
        Tabs,
        CompetenceItem,
        ReportingIcon,
    },
    async created() {
        this.loading = true;

        await Promise.all([this.loadTrack(), this.loadCompetences()]);

        this.loading = false;
    },
    data: () => ({
        loading: true,
        // Tabs removed https://jira.rsv.ru/browse/RD-1724
        tabs: [
            // { text: 'Компетенции', value: 'soft' },
            // { text: 'Профессиональные навыки', value: 'hard' },
        ],
        currentType: 'soft',
    }),
    methods: {
        ...mapActions('accountTrack', ['loadTrack']),
        ...mapActions('accountCompetences', ['loadCompetences']),
    },
    computed: {
        ...mapGetters('accountTrack', ['getTrackId']),
        ...mapGetters('accountCompetences', ['getCompetences']),
        emptyImgLink() {
            return require(`../../../assets/images/oops-rhino.svg`);
        },

        isTabsShown() {
            return this.tabs.length > 0;
        },

        tabItems() {
            let items = this.getCompetences.filter((v) => v.competenceType === this.currentType);

            items = [
                ...items.filter((v) => v.expertCompetenceLevel !== null).sort((a, b) => (a.name > b.name ? 1 : -1)),
                ...items
                    .filter((v) => v.expertCompetenceLevel === null && v.competenceLevel !== null)
                    .sort((a, b) => (a.name > b.name ? 1 : -1)),
            ];

            const groups = [];

            for (const item of items) {
                let group = groups.find((g) => g.name === item.competenceGroup);

                if (!group) {
                    group = {
                        name: item.competenceGroup,
                        items: [],
                    };
                    groups.push(group);
                }

                group.items.push(item);
            }

            return groups.sort((a, b) => {
                if (!a.name) return -1;
                if (!b.name) return 1;

                return a.name > b.name ? 1 : -1;
            });
        },
        catalogLink() {
            return {
                name: this.currentType === 'hard' ? 'professional-skills' : 'competences',
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';

.tab-wrapper {
    margin-top: rem(16);
    border-radius: rem(10);
    @include on-mobile {
        margin-top: 0;
    }
}

.account-link {
    font-family: 'Proxima Nova', sans-serif;
    font-style: normal;
    font-weight: 600;
    color: #4663ab;
    display: inline-block;
}
.competences-block {
    min-height: 100px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    font-weight: 500;
    font-size: rem(15);
    line-height: rem(22);
    color: #98a0a9;
    background: #ffffff;
    box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);
    border-radius: rem(10);
    padding: rem(32);

    @include on-mobile {
        font-size: mrem(15);
        line-height: mrem(22);
        padding: mrem(32) mrem(16);
        box-shadow: 0 mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
    }

    &__title {
        color: #2a2626;
        font-size: mrem(22) !important;
        font-weight: 600;
        line-height: mrem(32);
        margin-top: 0;

        @media (min-width: 450px) {
            font-weight: 700 !important;
            font-size: rem(20) !important;
            line-height: rem(32);
        }
    }

    &__tabs {
        margin-bottom: mrem(32);

        @include on-desktop {
            margin-bottom: rem(32);
        }
    }

    &__empty {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        color: #98a0a9;
        margin-bottom: mrem(24);
        font-size: mrem(18);
        line-height: mrem(24);

        @include on-desktop {
            margin-bottom: rem(24);
            font-size: rem(18);
            line-height: rem(24);
        }
    }

    &__buttons {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        row-gap: mrem(14);
        font-size: mrem(14);

        @include on-desktop {
            flex-direction: row;
            column-gap: rem(24);
        }

        .btn-catalog {
            width: 100%;
            border-radius: mrem(10);
            font-weight: 600;
            font-size: mrem(14);
            font-family: Montserrat, sans-serif;

            @include on-desktop {
                width: rem(204);
                border-radius: rem(10);
                font-size: rem(14);
            }
        }
        .btn-reports {
            width: 100%;
            border-radius: mrem(10);
            font-size: mrem(14);
            font-family: Montserrat, sans-serif;
            font-weight: 600;

            @include on-desktop {
                width: rem(267);
                border-radius: rem(10);
                font-size: rem(14);
            }

            .icon {
                width: mrem(24);
                height: mrem(24);
                margin-right: mrem(12);

                @include on-desktop {
                    width: rem(24);
                    height: rem(24);
                    margin-right: rem(12);
                }
            }
        }
    }

    hr {
        border: 0;
        height: 2px;
        background: #f0f0f0;
        width: 100%;
        margin: rem(40) 0 rem(40);

        @include on-mobile {
            margin: mrem(40) 0 mrem(40);
        }
    }

    .items {
        margin-top: mrem(32);

        @include on-desktop {
            margin-top: rem(32);
        }
    }

    h3 {
        color: $color-black-text;
        font-weight: 600;
        font-size: mrem(18);
        line-height: mrem(24);
        margin-top: 0;
        margin-bottom: mrem(24);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
            margin-bottom: rem(24);
        }
    }

    .competences-items {
        display: flex;
        flex-direction: column;
        gap: mrem(38);

        @include on-desktop {
            gap: rem(38);
        }
    }
}
</style>
